import React from "react"
import Typography from "../../../../ui/atoms/Typography"
import { AlgoliaStaticSearchFilter } from "../controller/state/types"

interface Props {
  title: string
  filters: AlgoliaStaticSearchFilter[]
}

const StaticSearchFilterCategory = ({ title, filters }: Props) => {
  return (
    <div>
      <Typography variant="subtitle2">{title}</Typography>
      {filters.map((x, i) => (
        <div key={i} className="my-4">
          <a href={x.url}>{x.name}</a>
        </div>
      ))}
    </div>
  )
}

export default StaticSearchFilterCategory
